<span>
  @if (args!='') {
    <img class="img-avatar "  [src]="_currentdata.imageUrl | secure  | async" alt="{{_currentdata.imageName}}" [width]="_currentdata.thumbWidth" [height]="_currentdata.thumbHeight" (click)="viewLargeImage()">
  }
</span>
@if (_currentdata.open) {
  <span>
    <div dhs-modal></div>
  </span>
}

